class CustomEngravingCustomizationOptions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.customEngraving2026 = document.querySelector("custom-engraving-2026");

    this.options = this.querySelector("#engraving-customizations-options");
    this.startBtn = this.querySelector("#engraving-customization-start");

    this.placeholderText = document.querySelector(
      "#engraving-preview-placeholder--text",
    );
    this.placeholderIcon = document.querySelector(
      "#engraving-preview-placeholder--icon",
    );
    this.placeholderCaseback = document.querySelector(
      "#engraving-option-caseback-placeholder",
    );
    this.placeholderIconURL =
      "https://cdn.shopify.com/s/files/1/0814/0539/files/Circle_Plus_Icon_ai.svg";
    this.placeholderCasebackURL = this.placeholderCaseback?.src || "";
    this.placeholderCasebackAlt =
      this.placeholderCaseback?.alt || "Engraving placeholder image";

    this.loadComponent();

    document.addEventListener(
      "custom-engraving-2026",
      this.customEngraving2026EventHandler.bind(this),
    );
    this.options.addEventListener("input", this.optionsEventHandler.bind(this));
    this.startBtn.addEventListener("click", this.scrollToNextScreen.bind(this));
  }
  customEngraving2026EventHandler(event) {
    this.loadComponent(event.detail);
  }

  loadComponent(eventProductEngravingSettings = false) {
    this.resetCustomizationOptions();

    const settings = eventProductEngravingSettings
      ? eventProductEngravingSettings
      : this.customEngraving2026.currentProductEngravingSettings;
    if (!settings) return;
    const { engravingService } = settings;
    const sidewall = engravingService.engravingType === "sidewall";
    this.placeholderCasebackURL = engravingService.customPreviewImage || (sidewall
      ? "https://cdn.shopify.com/s/files/1/0814/0539/files/Barrel_42mm_case_linedrawing.png"
      : "https://cdn.shopify.com/s/files/1/0814/0539/files/custom-engraving-206-option-caseback-placeholder.webp");
    this.placeholderCasebackAlt = sidewall ? "Sidewall engraving preview" : "Caseback engraving preview";
    this.placeholderCaseback.closest("#engraving-preview-placeholder").dataset.engravingType = engravingService.engravingType;
    this.querySelector("[data-engraving-text-price]").textContent = `$${engravingService.textPrice}`;
    this.resetElements();
    this.showEngravingCustomOptions(engravingService);
  }

  resetCustomizationOptions() {
    this.options.querySelectorAll("label").forEach((el) => {
      el.style.display = "none";
    });
  }

  showEngravingCustomOptions({
    availableEngravingCustomizations = [],
    customIcons = [],
  }) {
    availableEngravingCustomizations.forEach((item) => {
      if (item == "upload-text") {
        this.querySelector(`label[for="engraving-text"]`).style.display =
          "flex";
      }

      if (item == "custom-icons" && customIcons.length) {
        this.querySelector(`label[for="custom-icon"]`).style.display = "flex";
      }
    });
  }

  optionsEventHandler(event) {
    const option = event.target.value;
    this.setCustomizationNextStep(option);
  }

  setCustomizationNextStep(nextStep = "") {
    this.startBtn.disabled = false;
    this.startBtn.setAttribute("data-next-screen", nextStep);
  }

  scrollToNextScreen() {
    const { nextScreen } = this.startBtn.dataset;
    if (!nextScreen) return;

    if (nextScreen == "engraving-text") {
      this.resetCasebackPreview();
      this.placeholderText.style.display = "block";
      this.placeholderIcon.style.display = "none";
    }

    if (nextScreen == "engraving-custom-icon") {
      this.resetCasebackPreview();
      this.placeholderIcon.setAttribute("src", this.placeholderIconURL);
      this.placeholderIcon.alt = "Select a caseback design";
      this.placeholderIcon.style.display = "block";

      this.placeholderText.style.display = "none";
    }

    this.scrollToScreen(nextScreen);
  }

  setActiveScreen(screenName) {
    this.closest(".engraving-customizations")?.querySelectorAll(".engraving-customization-screen").forEach((screen) => {
      screen.inert = screen.dataset.screen !== screenName;
    });
  }

  scrollToOptionsScreen() {
    this.setActiveScreen("engraving-customizations-options");
    const track = this.closest(".engraving-customizations");
    track?.scrollTo({ left: 0, behavior: "auto" });
  }

  scrollToScreen(screenName, behavior = "smooth") {
    const track = this.closest(".engraving-customizations");
    const screen = track?.querySelector(
      `.engraving-customization-screen[data-screen="${screenName}"]`,
    );
    if (!track || !screen) return;
    this.setActiveScreen(screenName);

    const targetLeft =
      track.scrollLeft +
      screen.getBoundingClientRect().left -
      track.getBoundingClientRect().left;
    track.scrollTo({ left: targetLeft, behavior });
  }

  resetElements() {
    this.resetCasebackPreview();
    this.placeholderText.style.display = "none";
    this.placeholderIcon.setAttribute("src", this.placeholderIconURL);
    this.placeholderIcon.alt = "Engraving Icon";
    this.placeholderIcon.style.display = "none";
    this.options.querySelectorAll("label").forEach((el) => {
      const input = el.querySelector("input");
      if (input) input.checked = false;
    });
    this.startBtn.disabled = true;
    this.startBtn.removeAttribute("data-next-screen");
    this.scrollToOptionsScreen();
  }

  resetCasebackPreview() {
    if (!this.placeholderCaseback) return;
    this.placeholderCaseback.src = this.placeholderCasebackURL;
    this.placeholderCaseback.alt = this.placeholderCasebackAlt;
  }

  disconnectedCallback() {}
}

customElements.define(
  "custom-engraving-2026-customization-options",
  CustomEngravingCustomizationOptions,
);
